<template>
  <CModal
    :title="mensagem.titulo"
    :variant="mensagem.color"
    :color="mensagem.color"
    :centered="true"
    :show.sync="showModal"
  >
    {{ mensagem.message }}
    <div slot="footer">
      <CRow>
        <CCol class="mr-4" cols="1">
          <CButton color="success" @click.stop="$emit('onCancel')">
            Fechar
          </CButton>
        </CCol>
      </CRow>
    </div>
  </CModal>
</template>
<script>

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    mensagem: {
      titulo: {
        type: String,
        required: true,
        default: "",
      },
      color: {
        type: String,
        required: true,
        default: null,
      },
      message:{
        type: String,
        required: true,
        default: "",
      },
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
    }
  }
}
</script>
<style>
</style>
